import React, { useState } from 'react';
import './WidgetSettingsNumericValueEditor.scss';
import { CheckboxInput } from '@instinet-analytics/semantic-ui-components';
import { PartialRecord } from 'utils/partialRecord';

export interface WidgetSettingsCheckboxValueEditorProps<
    TKey extends string,
    TConfig extends PartialRecord<TKey, boolean | undefined>,
> {
    propertyName: TKey;
    config: TConfig;
    label: string;
    inverted?: boolean;
    onChange: (delta: Partial<TConfig>) => void;
}

export default function WidgetSettingsCheckboxValueEditor<
    TKey extends string,
    TConfig extends PartialRecord<TKey, boolean | undefined>,
>(props: WidgetSettingsCheckboxValueEditorProps<TKey, TConfig>) {
    const { config, onChange, propertyName, label, inverted } = props;
    const configValue = config[propertyName];

    const invert = (value: boolean) => (inverted ? !value : value);

    const [checkboxValue, setCheckboxValue] = useState(
        invert(configValue as boolean)
    );

    const onChanged = () => {
        const nextCheckboxValue = !checkboxValue;

        setCheckboxValue(nextCheckboxValue);

        const delta = {
            [propertyName]: invert(nextCheckboxValue),
        } as unknown as Partial<TConfig>;
        onChange(delta);
    };

    return (
        <>
            <CheckboxInput
                label={label}
                checked={checkboxValue}
                onToggle={onChanged}
                className={`checkbox-editor-${propertyName}`}
            />
        </>
    );
}
